import DurationIcon from "../Icons/DurationIcon";
import LessonsIcon from "../Icons/LessonsIcon";
import SkillIcon from "../Icons/SkillIcon";
import ViewsIcon from "../Icons/ViewsIcon";
// import FAQItem from "../Home/FAQItem";
import { CourseByIdDTO } from "../../api/Courses/GetCourseById";
import ReactMarkdown from "react-markdown";
import { Calendar } from "lucide-react";

const CoursePreview = ({ courses }: { courses?: CourseByIdDTO }) => {
  const getTotalLectures = () => {
    if (!courses || !courses.chapters) return 0;
    return courses.chapters.reduce(
      (total, chapter) =>
        total + (chapter.lectures ? chapter.lectures.length : 0),
      0
    );
  };

  return (
    <div className="xl:max-w-[800px]">
      <div className="flex justify-between pt-8 mb-8">
        <div className="flex items-center sm:gap-4 gap-2">
          <div className=" sm:size-20 size-12 rounded-full overflow-hidden border border-black/20">
            <img
              className="object-cover object-[25%_75%] "
              src={courses?.Instructor?.photo}
              alt="Instructor"
            />
          </div>
          <div className="text-burntBlack font-bold text-xl">
            <h1 className="mb-0.5 sm:text-xl text-lg">
              Dr. {courses?.Instructor?.firstName}{" "}
              {courses?.Instructor?.lastName}
            </h1>
            <p className="text-lightGray font-medium sm:text-lg tracking-[0.02em]">
              Instructor
            </p>
          </div>
        </div>
      </div>
      <div className="sm:mb-12 mb-7">
        <h1 className="font-bold sm:text-3xl  text-xl sm:mb-3 mb-1">
          {courses?.name}
        </h1>
        <h2 className="font-bold sm:text-2xl text-lg tracking-[0.02em] sm:mb-4 mb-2.5">
          Description
        </h2>
        <p className="font-medium sm:text-lg text-sm text-lightGray">
          <ReactMarkdown>{courses?.description}</ReactMarkdown>
        </p>
      </div>
      <div>
        <h1 className="font-bold sm:text-2xl text-lg tracking-[0.02em] sm:mb-6 mb-5">
          Course Details
        </h1>
        <div className="flex justify-between md:gap-5 gap-4 md:flex-nowrap flex-wrap">
          <div className="text-white bg-primary sm:h-[88px] h-20 md:w-[180px] pl-5  rounded-lg flex flex-col gap-1.5 justify-center w-1/2 basis-[calc(50%_-8px)]">
            <h1 className="font-medium text-lg sm:text-xl">Lessons</h1>
            <div className="flex items-center sm:text-base text-sm gap-2">
              <LessonsIcon />{" "}
              <span className="font-bold">{getTotalLectures()}</span>
            </div>
          </div>
          <div className="  sm:h-[88px] h-20 md:w-[180px] pl-5  bg-[#F5F5F5] border border-black/15 rounded-lg flex flex-col gap-1.5 justify-center w-1/2 basis-[calc(50%_-8px)]">
            <h1 className="font-medium text-lg sm:text-xl text-lightGray">
              Duration
            </h1>
            <div className="flex items-center sm:text-base text-sm gap-2 text-primary">
              <DurationIcon isActive={true} />{" "}
              <span className="font-bold">{courses?.num_hours}h</span>
            </div>
          </div>
          {courses?.startDate ? (
            <>
              <div className="  sm:h-[88px] h-20 md:w-[180px] pl-5  bg-[#F5F5F5] border border-black/15 rounded-lg flex flex-col gap-1.5 justify-center w-1/2 basis-[calc(50%_-8px)]">
                <h1 className="font-medium text-lg sm:text-xl text-lightGray">
                  Start Date
                </h1>
                <div className="flex items-center sm:text-base text-sm gap-2 text-primary">
                  <Calendar />{" "}
                  <span className="font-bold">{courses?.startDate}</span>
                </div>
              </div>
              <div className="  sm:h-[88px] h-20 md:w-[180px] pl-5  bg-[#F5F5F5] border border-black/15 rounded-lg flex flex-col gap-1.5 justify-center w-1/2 basis-[calc(50%_-8px)]">
                <h1 className="font-medium text-lg sm:text-xl text-lightGray">
                  Course Type
                </h1>
                <div
                  className={`flex items-center sm:text-base text-sm gap-2 ${
                    courses.isLive ? "text-green-500" : "text-red-500"
                  }`}
                >
                  <ViewsIcon />{" "}
                  <span className="font-bold">
                    {courses.isLive ? "Live Sessions" : "Offline Sessions"}
                  </span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="  sm:h-[88px] h-20 md:w-[180px] pl-5  bg-[#F5F5F5] border border-black/15 rounded-lg flex flex-col gap-1.5 justify-center w-1/2 basis-[calc(50%_-8px)]">
                <h1 className="font-medium text-lg sm:text-xl text-lightGray">
                  Skill Level
                </h1>
                <div className="flex items-center sm:text-base text-sm gap-2 text-primary">
                  <SkillIcon /> <span className="font-bold">Beginner</span>
                </div>
              </div>
              <div className="  sm:h-[88px] h-20 md:w-[180px] pl-5  bg-[#F5F5F5] border border-black/15 rounded-lg flex flex-col gap-1.5 justify-center w-1/2 basis-[calc(50%_-8px)]">
                <h1 className="font-medium text-lg sm:text-xl text-lightGray">
                  Students
                </h1>
                <div className="flex items-center sm:text-base text-sm gap-2 text-primary">
                  <ViewsIcon />{" "}
                  <span className="font-bold">{courses?._count?.students}</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {!!courses?.video && <div className="mt-10">
        <h1 className="font-bold sm:text-2xl text-lg tracking-[0.02em] sm:mb-6 mb-5">
          Free Lecture
        </h1>
        <div className="flex justify-between md:gap-5 gap-4 md:flex-nowrap flex-wrap">
          <iframe
            src={`https://player.vdocipher.com/v2/?otp=${courses?.video.otp}&playbackInfo=${courses?.video.playbackInfo}`}
            // src={currentVideoUrl}
            className="w-full sm:h-[450px] h-[300px] object-cover border-0"
            // style={{border:0, maxWidth:'100%', position:'absolute', top:0, left:0, height:'300px', width:'100%'}}
            allow="encrypted-media"
            allowFullScreen
          ></iframe>
        </div>
      </div>}
    </div>
  );
};

export default CoursePreview;
